export default __webpack_public_path__ + "static/1592-fc6f720f0788ef46ee0678104fd90fc5.gif";